import { createApp } from 'vue'
import App from './App.vue'

import router from "./router";
import store from "./store";
import InlineSvg from 'vue-inline-svg';
import ElementPlus from "element-plus";
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import ApiService from "@/core/services/ApiService";
import photoSwipePlugin from './core/plugins/photoSwipePlugin';
import ZhiService from "@/core/services/ZhiService";
import VueLazyload from 'vue-lazyload'

const app = createApp(App);
app.use(store);
app.use(router);
app.use(ElementPlus,{
    locale: zhCn
});
app.use(VueLazyload)
app.use(photoSwipePlugin);
app.component('inline-svg', InlineSvg);
ApiService.init(app);

// import eruda from "eruda"

// if(ZhiService.isMobile()){
//     eruda.init()
// }

app.mount('#app');
